import { Box, TablePagination } from '@mui/material';

/**
 * Pager for the events tables. The rows are already only the current page, so
 * this reports which page to load next rather than slicing anything locally.
 */
const EventPagination = ({ count, page, rowsPerPage, onPageChange }) => {
  if (count === 0) {
    return null;
  }

  return (
    <Box sx={{ display: 'flex', justifyContent: 'flex-end', mt: 1 }}>
      <TablePagination
        component="div"
        count={count}
        page={page}
        rowsPerPage={rowsPerPage}
        rowsPerPageOptions={[rowsPerPage]}
        onPageChange={(event, nextPage) => onPageChange(nextPage)}
        labelDisplayedRows={({ from, to, count: total }) => `${from}–${to} of ${total}`}
        sx={{ border: 0 }}
      />
    </Box>
  );
};

export default EventPagination;
